import { render } from "./BasicLayout.vue?vue&type=template&id=724131fc&scoped=true&ts=true"
import script from "./BasicLayout.vue?vue&type=script&lang=ts"
export * from "./BasicLayout.vue?vue&type=script&lang=ts"

import "./BasicLayout.vue?vue&type=style&index=0&id=724131fc&lang=scss&scoped=true"

import exportComponent from "/Users/zhouyuan/work/project/cargpsweb-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724131fc"]])

export default __exports__